import React, { useEffect, useState } from "react";
import { Button, DatePicker, Input, Switch } from "antd";
import { SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import useUserData from "../../../../hooks/useUserData";
import moment from "moment";
import {
  currentUnits,
  pressureUnits,
  temperatureUnits,
  vibrationUnits,
} from "../../../../Data/data";
import UnitWithInput from "../../../../components/UnitWithInput";
import dayjs from "dayjs";
import { useDate } from "../../../../context/DateContext";

function AuxiliaryCompressor({ eng_log_basic_id, _items }) {
  const user = useUserData();
  const { selectedDate } = useDate();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [st_Stage_Suc, set_1st_Stage_Suc] = useState("");
  const [st_Stage_Disch, set_1st_Stage_Disch] = useState("");
  const [nd_Stage_Suc, set_2nd_Stage_Suc] = useState("");
  const [nd_Stage_Disch, set_2nd_Stage_Disch] = useState("");
  const [lo_pr, set_Lo_Pr] = useState("");
  const [cw_Pr, set_Cw_Pr] = useState("");
  const [cw_Temp, set_Cw_Temp] = useState("");
  const [motor_Current, set_Motor_Current] = useState("");
  const [motor_Temp, set_Motor_Temp] = useState("");
  const [checked, setChecked] = useState(false);
  const [running_Hour, set_Running_Hour] = useState("");
  const [total_Running_Hour, set_Total_Running_Hour] = useState("");
  const [update_status, set_update_status] = useState(false);
  const [auxi_compressor_id, set_auxi_compressor_id] = useState("");
  const [submitStatus, setSubmitStatus] = useState(false);
  const [logDate, set_LogDate] = useState(null);
  const [st_Stage_Suc_Unit, set_1st_Stage_Suc_Unit] = useState("");
  const [st_Stage_Disch_Unit, set_1st_Stage_Disch_Unit] = useState("");
  const [nd_Stage_Suc_Unit, set_2nd_Stage_Suc_Unit] = useState("");
  const [nd_Stage_Disch_Unit, set_2nd_Stage_Disch_Unit] = useState("");
  const [lo_Pr_Unit, set_Lo_Pr_Unit] = useState("");
  const [cw_Pr_Unit, set_Cw_Pr_Unit] = useState("");
  const [cw_Temp_Unit, set_Cw_Temp_Unit] = useState("");
  const [motor_Current_Unit, set_Motor_Current_Unit] = useState("");
  const [motor_Temp_Unit, set_Motor_Temp_Unit] = useState("");
  const [otherParams, setOtherParams] = useState({});

  // Map parameter names to labels and units
  const parameterConfig = {
    runningHours: { label: "Running Hour", unitList: [] },
    totalRunningHours: { label: "Total Running Hour", unitList: [] },
    firstStageSuctionPressure: {
      label: "1st Stage Suction Pressure",
      unitList: pressureUnits,
    },
    firstStageDischargePressure: {
      label: "1st Stage Discharge Pressure",
      unitList: pressureUnits,
    },
    secondStageSuctionPressure: {
      label: "2nd Stage Suction Pressure",
      unitList: pressureUnits,
    },
    secondStageDischargePressure: {
      label: "2nd Stage Discharge Pressure",
      unitList: pressureUnits,
    },
    lubeOilPressure: { label: "Lube Oil Pressure", unitList: pressureUnits },
    coolingWaterPressure: {
      label: "Cooling Water Pressure",
      unitList: pressureUnits,
    },
    coolingWaterTemp: {
      label: "Cooling Water Temp",
      unitList: temperatureUnits,
    },
    motorCurrent: { label: "Motor Current", unitList: currentUnits },
    motorTemp: { label: "Motor Temp", unitList: temperatureUnits },
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    if (parsedData && _items) {
      VIEW_AUXILARY_COMPRESSOR_DETAILS_LOGBOOK_API(_items?.id, parsedData);
      // Safely initialize other parameters
      const otherParamsData = Array.isArray(_items?.other_parameters)
        ? _items.other_parameters
        : [];
      const initialOtherParams = otherParamsData.reduce((acc, param) => {
        acc[param.name] = { value: "", unit: param.unit || "" };
        return acc;
      }, {});
      setOtherParams(initialOtherParams);
    }
  }, [_items?.id]);

  const onChangeDateTime = (value) => {
    if (value) {
      set_LogDate(value.format("YYYY-MM-DD HH:mm:ss"));
    } else {
      set_LogDate(null);
    }
  };

  const handleOtherParamChange = (name, field, value) => {
    setOtherParams((prev) => ({
      ...prev,
      [name]: { ...prev[name], [field]: value },
    }));
  };

  const ADD_AUXILARY_COMPRESSOR_DETAILS_LOGBOOK_API = async (
    compressor_id,
    compressor_on
  ) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append(
        "date_time_log",
        logDate || moment().format("YYYY-MM-DD HH:mm:ss")
      );
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
      FORM_DATA.append(
        "voyage_id",
        Number(staff_dashboard?.voyage_details?.[0]?.id) || 0
      );
      FORM_DATA.append("compressor_id", Number(compressor_id) || 0);
      FORM_DATA.append(
        "com_first_stage_suction_press",
        Number(st_Stage_Suc) || 0
      );
      FORM_DATA.append(
        "com_first_stage_discharge_press",
        Number(st_Stage_Disch) || 0
      );
      FORM_DATA.append(
        "com_second_stage_suction_press",
        Number(nd_Stage_Suc) || 0
      );
      FORM_DATA.append(
        "com_second_stage_discharge_press",
        Number(nd_Stage_Disch) || 0
      );
      FORM_DATA.append("com_lube_oil_press", Number(lo_pr) || 0);
      FORM_DATA.append("com_cooling_water_press", Number(cw_Pr) || 0);
      FORM_DATA.append("com_cooling_water_temp", Number(cw_Temp) || 0);
      FORM_DATA.append("com_motor_current", Number(motor_Current) || 0);
      FORM_DATA.append("com_motor_temp", Number(motor_Temp) || 0);
      FORM_DATA.append("compressor_on_off", compressor_on);
      FORM_DATA.append("compressor_running_hours", Number(running_Hour) || 0);
      FORM_DATA.append(
        "compressor_total_running_hours",
        Number(total_Running_Hour) || 0
      );
      FORM_DATA.append(
        "com_first_stage_suction_press_unit",
        st_Stage_Suc_Unit || ""
      );
      FORM_DATA.append(
        "com_first_stage_discharge_press_unit",
        st_Stage_Disch_Unit || ""
      );
      FORM_DATA.append(
        "com_second_stage_suction_press_unit",
        nd_Stage_Suc_Unit || ""
      );
      FORM_DATA.append(
        "com_second_stage_discharge_press_unit",
        nd_Stage_Disch_Unit || ""
      );
      FORM_DATA.append("com_lube_oil_press_unit", lo_Pr_Unit || "");
      FORM_DATA.append("com_cooling_water_press_unit", cw_Pr_Unit || "");
      FORM_DATA.append("com_cooling_water_temp_unit", cw_Temp_Unit || "");
      FORM_DATA.append("com_motor_current_unit", motor_Current_Unit || "");
      FORM_DATA.append("com_motor_temp_unit", motor_Temp_Unit || "");
      FORM_DATA.append("other_parameters", JSON.stringify(otherParams));

      post(ApiURL.add_auxiliary_compressor_info_st, FORM_DATA).then((res) => {
        if (res?.status === true) {
          SuccessToast(
            "Logbook Add Success!",
            "Logbook Auxilary Compressor details have been successfully Add!"
          );
          set_loader(false);
          if (staff_dashboard)
            VIEW_AUXILARY_COMPRESSOR_DETAILS_LOGBOOK_API(
              res?.compressor_data?.compressor_id,
              staff_dashboard
            );
        } else {
          set_loader(false);
          const errors = res?.errors || {};
          set_errors(errors);
        }
      });
    } catch (error) {
      console.error("Error Adding logbook:", error);
    } finally {
    }
  };

  const UPDATE_AUXILARY_COMPRESSOR_DETAILS_LOGBOOK_API = async (
    compressor_id,
    auxi_compressor_id,
    save_submit,
    compressor_on
  ) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append(
        "date_time_log",
        logDate || moment().format("YYYY-MM-DD HH:mm:ss")
      );
      FORM_DATA.append("save_submit", Number(save_submit) || 0);
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
      FORM_DATA.append(
        "voyage_id",
        Number(staff_dashboard?.voyage_details?.[0]?.id) || 0
      );
      FORM_DATA.append("compressor_id", Number(compressor_id) || 0);
      FORM_DATA.append("auxi_compressor_id", Number(auxi_compressor_id) || 0);
      FORM_DATA.append(
        "com_first_stage_suction_press",
        Number(st_Stage_Suc) || 0
      );
      FORM_DATA.append(
        "com_first_stage_discharge_press",
        Number(st_Stage_Disch) || 0
      );
      FORM_DATA.append(
        "com_second_stage_suction_press",
        Number(nd_Stage_Suc) || 0
      );
      FORM_DATA.append(
        "com_second_stage_discharge_press",
        Number(nd_Stage_Disch) || 0
      );
      FORM_DATA.append("com_lube_oil_press", Number(lo_pr) || 0);
      FORM_DATA.append("com_cooling_water_press", Number(cw_Pr) || 0);
      FORM_DATA.append("com_cooling_water_temp", Number(cw_Temp) || 0);
      FORM_DATA.append("com_motor_current", Number(motor_Current) || 0);
      FORM_DATA.append("com_motor_temp", Number(motor_Temp) || 0);
      FORM_DATA.append("compressor_on_off", compressor_on);
      FORM_DATA.append("compressor_running_hours", Number(running_Hour) || 0);
      FORM_DATA.append(
        "compressor_total_running_hours",
        Number(total_Running_Hour) || 0
      );
      FORM_DATA.append(
        "com_first_stage_suction_press_unit",
        st_Stage_Suc_Unit || ""
      );
      FORM_DATA.append(
        "com_first_stage_discharge_press_unit",
        st_Stage_Disch_Unit || ""
      );
      FORM_DATA.append(
        "com_second_stage_suction_press_unit",
        nd_Stage_Suc_Unit || ""
      );
      FORM_DATA.append(
        "com_second_stage_discharge_press_unit",
        nd_Stage_Disch_Unit || ""
      );
      FORM_DATA.append("com_lube_oil_press_unit", lo_Pr_Unit || "");
      FORM_DATA.append("com_cooling_water_press_unit", cw_Pr_Unit || "");
      FORM_DATA.append("com_cooling_water_temp_unit", cw_Temp_Unit || "");
      FORM_DATA.append("com_motor_current_unit", motor_Current_Unit || "");
      FORM_DATA.append("com_motor_temp_unit", motor_Temp_Unit || "");
      FORM_DATA.append("other_parameters", JSON.stringify(otherParams));

      post(ApiURL.view_update_auxiliary_compressor_st, FORM_DATA).then(
        (res) => {
          if (res?.status === true) {
            SuccessToast(
              "Logbook Update Success!",
              "Logbook Auxilary Compressor details have been successfully Update!"
            );
            set_loader(false);
            if (staff_dashboard)
              VIEW_AUXILARY_COMPRESSOR_DETAILS_LOGBOOK_API(
                res?.compressor_data?.compressor_id,
                staff_dashboard
              );
          } else {
            set_loader(false);
            const errors = res?.errors || {};
            set_errors(errors);
          }
        }
      );
    } catch (error) {
      console.error("Error Updated logbook:", error);
    } finally {
    }
  };

  const VIEW_AUXILARY_COMPRESSOR_DETAILS_LOGBOOK_API = async (
    compressor_Id,
    voyage_id
  ) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("compressor_id", compressor_Id);
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      FORM_DATA.append("voyage_id", voyage_id?.voyage_details?.[0]?.id);
      post(ApiURL.view_update_auxiliary_compressor_st, FORM_DATA).then(
        (res) => {
          const compressor_data = res?.compressor_data;
          if (res?.status === true) {
            set_update_status(compressor_data?.complete_status);
            set_auxi_compressor_id(compressor_data?.auxi_compressor_id);
            set_1st_Stage_Suc(
              compressor_data?.com_first_stage_suction_press || ""
            );
            set_1st_Stage_Disch(
              compressor_data?.com_first_stage_discharge_press || ""
            );
            set_2nd_Stage_Suc(
              compressor_data?.com_second_stage_suction_press || ""
            );
            set_2nd_Stage_Disch(
              compressor_data?.com_second_stage_discharge_press || ""
            );
            set_Lo_Pr(compressor_data?.com_lube_oil_press || "");
            set_Cw_Pr(compressor_data?.com_cooling_water_press || "");
            set_Cw_Temp(compressor_data?.com_cooling_water_temp || "");
            set_Motor_Current(compressor_data?.com_motor_current || "");
            set_Motor_Temp(compressor_data?.com_motor_temp || "");
            setChecked(compressor_data?.compressor_on_off || false);
            set_Running_Hour(compressor_data?.compressor_running_hours || "");
            set_Total_Running_Hour(
              compressor_data?.compressor_total_running_hours || ""
            );
            setSubmitStatus(res?.submit_status || false);
            set_LogDate(
              compressor_data?.date_time_log ||
                moment().format("YYYY-MM-DD HH:mm:ss")
            );
            set_1st_Stage_Suc_Unit(
              compressor_data?.com_first_stage_suction_press_unit || ""
            );
            set_1st_Stage_Disch_Unit(
              compressor_data?.com_first_stage_discharge_press_unit || ""
            );
            set_2nd_Stage_Suc_Unit(
              compressor_data?.com_second_stage_suction_press_unit || ""
            );
            set_2nd_Stage_Disch_Unit(
              compressor_data?.com_second_stage_discharge_press_unit || ""
            );
            set_Lo_Pr_Unit(compressor_data?.com_lube_oil_press_unit || "");
            set_Cw_Pr_Unit(compressor_data?.com_cooling_water_press_unit || "");
            set_Cw_Temp_Unit(
              compressor_data?.com_cooling_water_temp_unit || ""
            );
            set_Motor_Current_Unit(
              compressor_data?.com_motor_current_unit || ""
            );
            set_Motor_Temp_Unit(compressor_data?.com_motor_temp_unit || "");

            const rawItemParams = _items?.other_parameters;
            const itemParams = Array.isArray(rawItemParams)
              ? rawItemParams
              : [];
            const compressorParams = compressor_data?.other_parameters || {};

            // Merge the two datasets
            const mergedParams = itemParams?.map((param) => {
              const paramName = param.name;
              const compressorEntry = compressorParams[paramName] || {};
              return {
                name: paramName,
                unit: param.unit || compressorEntry.unit || "",
                value: compressorEntry.value || "",
              };
            });

            const otherParamsData = Array.isArray(mergedParams)
              ? mergedParams
              : [];
            const initialOtherParams = otherParamsData.reduce((acc, param) => {
              acc[param.name] = {
                value: param.value || "",
                unit: param.unit || "",
              };
              return acc;
            }, {});

            setOtherParams(initialOtherParams);
          } else {
            const errors = res?.errors || {};
            set_errors(errors);
          }
        }
      );
    } catch (error) {
      console.error("Error updating logbook:", error);
    }
  };

  const otherParameterUnits = [
    ...new Set(Object.values(otherParams || {}).map((param) => param.unit)),
  ];

  return (
    <>
      <div className="row custom-box">
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "15px" }}>
            Compressor Make:- {_items?.compressor_make}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "15px" }}>
            Compressor Model:- {_items?.compressor_model}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "15px" }}>
            Compressor title:- {_items?.title}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "15px" }}>
            Compressor Id:- {_items?.id}
          </b>
        </div>
        <div className="col-2">
          <Switch
            disabled={submitStatus}
            checked={checked}
            onChange={(value) => {
              setChecked(value);
              if (value || !value) {
                update_status
                  ? UPDATE_AUXILARY_COMPRESSOR_DETAILS_LOGBOOK_API(
                      _items?.id,
                      auxi_compressor_id,
                      "0",
                      value
                    )
                  : ADD_AUXILARY_COMPRESSOR_DETAILS_LOGBOOK_API(
                      _items?.id,
                      value
                    );
              }
            }}
            checkedChildren="On"
            unCheckedChildren="Off"
            style={{ backgroundColor: checked ? "green" : "red" }}
          />
        </div>
      </div>

      {checked && (
        <>
          {(() => {
            const selectedParams = _items.selected_parameters || [];
            const rows = [];
            let i = 0;

            // Handle first row separately (Date + 2 params)
            const firstRowParams = selectedParams.slice(0, 2);
            rows.push(
              <div className="row" key="row-0">
                {/* Date picker column */}
                <div className="col-4">
                  <div className="input-box">
                    <label>Date & Time</label>
                    <DatePicker
                      showTime
                      format="YYYY-MM-DD HH:mm:ss"
                      placeholder="Select Date & Time"
                      // value={logDate ? dayjs(logDate, "YYYY-MM-DD HH:mm:ss") : null}
                      value={
                        update_status && logDate
                          ? dayjs(logDate, "YYYY-MM-DD HH:mm:ss")
                          : selectedDate
                          ? dayjs(selectedDate, "YYYY-MM-DD HH:mm:ss")
                          : null
                      }
                      onChange={onChangeDateTime}
                      style={{ width: "100%" }}
                      // disabled={submitStatus}
                      disabled
                    />
                    {errors.date_time_log && (
                      <p className="error-text">{errors.date_time_log}</p>
                    )}
                  </div>
                </div>

                {firstRowParams.map((param) => {
                  const config = parameterConfig[param];
                  if (!config) return null;

                  const stateMap = {
                    runningHours: [running_Hour, set_Running_Hour],
                    totalRunningHours: [
                      total_Running_Hour,
                      set_Total_Running_Hour,
                    ],
                    firstStageSuctionPressure: [
                      st_Stage_Suc,
                      set_1st_Stage_Suc,
                    ],
                    firstStageDischargePressure: [
                      st_Stage_Disch,
                      set_1st_Stage_Disch,
                    ],
                    secondStageSuctionPressure: [
                      nd_Stage_Suc,
                      set_2nd_Stage_Suc,
                    ],
                    secondStageDischargePressure: [
                      nd_Stage_Disch,
                      set_2nd_Stage_Disch,
                    ],
                    lubeOilPressure: [lo_pr, set_Lo_Pr],
                    coolingWaterPressure: [cw_Pr, set_Cw_Pr],
                    coolingWaterTemp: [cw_Temp, set_Cw_Temp],
                    motorCurrent: [motor_Current, set_Motor_Current],
                    motorTemp: [motor_Temp, set_Motor_Temp],
                  };
                  const [value, setValue] = stateMap[param] || [];
                  const unitStateMap = {
                    firstStageSuctionPressure: [
                      st_Stage_Suc_Unit,
                      set_1st_Stage_Suc_Unit,
                    ],
                    firstStageDischargePressure: [
                      st_Stage_Disch_Unit,
                      set_1st_Stage_Disch_Unit,
                    ],
                    secondStageSuctionPressure: [
                      nd_Stage_Suc_Unit,
                      set_2nd_Stage_Suc_Unit,
                    ],
                    secondStageDischargePressure: [
                      nd_Stage_Disch_Unit,
                      set_2nd_Stage_Disch_Unit,
                    ],
                    lubeOilPressure: [lo_Pr_Unit, set_Lo_Pr_Unit],
                    coolingWaterPressure: [cw_Pr_Unit, set_Cw_Pr_Unit],
                    coolingWaterTemp: [cw_Temp_Unit, set_Cw_Temp_Unit],
                    motorCurrent: [motor_Current_Unit, set_Motor_Current_Unit],
                    motorTemp: [motor_Temp_Unit, set_Motor_Temp_Unit],
                  };
                  const [unit, setUnit] = unitStateMap[param] || [];
                  const errorKey = `com_${param.replace(
                    /([A-Z])/g,
                    (match) => `_${match.toLowerCase()}`
                  )}`;

                  return (
                    <div className="col-4" key={param}>
                      {config.unitList.length ? (
                        <UnitWithInput
                          label={config.label}
                          value={value}
                          onChange={(e) => setValue(e.target.value)}
                          unit={unit}
                          onUnitChange={(e) => setUnit(e.target.value)}
                          disabled={submitStatus}
                          error={errors[errorKey]}
                          unitList={config.unitList}
                        />
                      ) : (
                        <div className="input-box">
                          <label>{config.label}</label>
                          <Input
                            disabled={submitStatus}
                            value={value}
                            placeholder={config.label}
                            onChange={(e) => setValue(e.target.value)}
                          />
                          {errors?.[errorKey] && (
                            <span style={{ color: "red" }}>
                              {errors[errorKey]}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );

            // Remaining rows (start from index 2)
            for (i = 2; i < selectedParams.length; i += 3) {
              const group = selectedParams.slice(i, i + 3);
              rows.push(
                <div className="row" key={`row-${i}`}>
                  {group.map((param) => {
                    const config = parameterConfig[param];
                    if (!config) return null;

                    const stateMap = {
                      runningHours: [running_Hour, set_Running_Hour],
                      totalRunningHours: [
                        total_Running_Hour,
                        set_Total_Running_Hour,
                      ],
                      firstStageSuctionPressure: [
                        st_Stage_Suc,
                        set_1st_Stage_Suc,
                      ],
                      firstStageDischargePressure: [
                        st_Stage_Disch,
                        set_1st_Stage_Disch,
                      ],
                      secondStageSuctionPressure: [
                        nd_Stage_Suc,
                        set_2nd_Stage_Suc,
                      ],
                      secondStageDischargePressure: [
                        nd_Stage_Disch,
                        set_2nd_Stage_Disch,
                      ],
                      lubeOilPressure: [lo_pr, set_Lo_Pr],
                      coolingWaterPressure: [cw_Pr, set_Cw_Pr],
                      coolingWaterTemp: [cw_Temp, set_Cw_Temp],
                      motorCurrent: [motor_Current, set_Motor_Current],
                      motorTemp: [motor_Temp, set_Motor_Temp],
                    };
                    const [value, setValue] = stateMap[param] || [];
                    const unitStateMap = {
                      firstStageSuctionPressure: [
                        st_Stage_Suc_Unit,
                        set_1st_Stage_Suc_Unit,
                      ],
                      firstStageDischargePressure: [
                        st_Stage_Disch_Unit,
                        set_1st_Stage_Disch_Unit,
                      ],
                      secondStageSuctionPressure: [
                        nd_Stage_Suc_Unit,
                        set_2nd_Stage_Suc_Unit,
                      ],
                      secondStageDischargePressure: [
                        nd_Stage_Disch_Unit,
                        set_2nd_Stage_Disch_Unit,
                      ],
                      lubeOilPressure: [lo_Pr_Unit, set_Lo_Pr_Unit],
                      coolingWaterPressure: [cw_Pr_Unit, set_Cw_Pr_Unit],
                      coolingWaterTemp: [cw_Temp_Unit, set_Cw_Temp_Unit],
                      motorCurrent: [
                        motor_Current_Unit,
                        set_Motor_Current_Unit,
                      ],
                      motorTemp: [motor_Temp_Unit, set_Motor_Temp_Unit],
                    };
                    const [unit, setUnit] = unitStateMap[param] || [];
                    const errorKey = `com_${param.replace(
                      /([A-Z])/g,
                      (match) => `_${match.toLowerCase()}`
                    )}`;

                    return (
                      <div className="col-4" key={param}>
                        {config.unitList.length ? (
                          <UnitWithInput
                            label={config.label}
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            unit={unit}
                            onUnitChange={(e) => setUnit(e.target.value)}
                            disabled={submitStatus}
                            error={errors[errorKey]}
                            unitList={config.unitList}
                          />
                        ) : (
                          <div className="input-box">
                            <label>{config.label}</label>
                            <Input
                              disabled={submitStatus}
                              value={value}
                              placeholder={config.label}
                              onChange={(e) => setValue(e.target.value)}
                            />
                            {errors?.[errorKey] && (
                              <span style={{ color: "red" }}>
                                {errors[errorKey]}
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              );
            }

            return rows;
          })()}

          <div className="row">
            {typeof otherParams === "object" && otherParams !== null
              ? Object.entries(otherParams).map(([name, { value, unit }]) => (
                  <div className="col-4" key={name}>
                    <UnitWithInput
                      label={name}
                      value={value}
                      onChange={(e) =>
                        handleOtherParamChange(name, "value", e.target.value)
                      }
                      unit={unit}
                      onUnitChange={(e) =>
                        handleOtherParamChange(name, "unit", e.target.value)
                      }
                      disabled={submitStatus}
                      unitList={otherParameterUnits}
                    />
                  </div>
                ))
              : null}
          </div>

          <div
            className="row"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              marginLeft: "5px",
            }}
          >
            {["Chief Engineer"].includes(user?.data?.designation) &&
              eng_log_basic_id && (
                <Button
                  disabled={submitStatus}
                  loading={loader}
                  className="save_btn"
                  style={{ color: "white" }}
                  onClick={() =>
                    update_status
                      ? UPDATE_AUXILARY_COMPRESSOR_DETAILS_LOGBOOK_API(
                          _items?.id,
                          auxi_compressor_id,
                          "1",
                          checked
                        )
                      : ADD_AUXILARY_COMPRESSOR_DETAILS_LOGBOOK_API(
                          _items?.id,
                          checked
                        )
                  }
                >
                  Submit
                </Button>
              )}
            <Button
              disabled={submitStatus}
              loading={loader}
              className="save_btn"
              style={{ color: "white" }}
              onClick={() =>
                update_status
                  ? UPDATE_AUXILARY_COMPRESSOR_DETAILS_LOGBOOK_API(
                      _items?.id,
                      auxi_compressor_id,
                      "0",
                      checked
                    )
                  : ADD_AUXILARY_COMPRESSOR_DETAILS_LOGBOOK_API(
                      _items?.id,
                      checked
                    )
              }
            >
              Save
            </Button>
          </div>
        </>
      )}
    </>
  );
}

export default AuxiliaryCompressor;
